import closeIcon from '@/components/Icons/Modals/IconClose.vue';
import { async } from 'q';

export default{
	mounted(){
		setTimeout(() => this.modalActive = true, 300);
	},

	data(){
		return{
			id: null,
			modalActive: false,
			responseReady: false,
			success: '',
			editUserSuccess: false,
			typeSelectFlag: false,
			tempSelect: "Selecciona...",

			///////////////
			//// EDIT USER
			editUser:{
				password: "",
				newPassword: "",
				newPasswordConfirm: "",
				email: "",
				type: ""
			},
			
			options: [
				{label: 'Administrador', value: 'admin'},
				{label: 'Consejo', value: 'comun'}
			]
		}
	},

	// props: ['section'],
	
	components:{
		closeIcon,
	},

	methods:{
		closeModal(){

			this.$parent.modal_editUser = false;
			this.editUserSuccess = false;

		},
		getUser(){

			

		},
		editUserF(scope){return;
			this.$validator.validateAll(scope).then((result) => {
				if(result){
		
					(async () => {
						var data = JSON.parse(JSON.stringify(this.editUser));
						data._id = this.$session.get('_id');
			
						await fetch('https://sandbox.api.salonacme.com/manager/edit_user', {
							method: 'POST',
							headers:{
							'Content-Type': 'application/json'
							},
							body: JSON.stringify(data)
						}).then(async response => {
							response = await response.json();
							if(response.status)
							{
								this.editUserSuccess = true;
								this.$parent.get_users();
							}else{
							alert(response.msg);
							}
						})
						.catch(error => alert(error));
					})();
		
				}
			});

		}
	},
	mounted(){
		// this.editUser = this.$parent.editUserData;
	}

}